import { QueryOptions, queryOptions } from '@tanstack/react-query';
import { service } from '@maia/customer';

export type Customers = Awaited<ReturnType<(typeof service)['getCustomers']>>;

export function getCustomersOptions(
  search: Record<string, unknown> = {},
  initialData: QueryOptions<Customers>['initialData'] = undefined,
) {
  return queryOptions({
    queryKey: ['Customers', search],
    queryFn: async () => await service.getCustomers(search),
    initialData,
  });
}
